module.exports = __webpack_public_path__ + "svg_80x80/javascript.aac5e2.svg";